import { selectFolder } from '@lmt/unicorn-shared/app/helpers/download-files';
import { Input } from './Input';
import FolderIcon from '@lmt/unicorn-shared/app/icons/folder.svg?react';
import React from 'react';
import { isElectron } from '@lmt/unicorn-shared/app/helpers/common';
import { useEventCallback } from '@mui/material';
import styles from './SelectFolderInput.module.scss';
import clsx from 'clsx';

export type Props = React.InputHTMLAttributes<HTMLInputElement> & {
  errorText?: string;
  variant?: 'normal' | 'formInput';
  testId?: string;
  changeValue: (value: string) => void;
};

export const SelectFolderInput = React.forwardRef<HTMLInputElement, Props>(
  function SelectFolderInput(props, ref) {
    const {
      onClick,
      errorText,
      type,
      variant,
      testId,
      changeValue,
      className,
      disabled,
      ...rest
    } = props;
    const onButtonClick = useEventCallback(async () => {
      const folder = await selectFolder();
      if (folder) {
        changeValue(folder);
      }
    });
    return (
      <Input
        ref={ref}
        disabled={disabled}
        endAdornment={
          isElectron() && (
            <div className={styles.container} data-disabled={disabled}>
              <FolderIcon onClick={onButtonClick} className={styles.icon} />
            </div>
          )
        }
        className={clsx(styles.input, className)}
        errorText={errorText}
        variant={variant}
        {...rest}
      />
    );
  },
);
